mutation CachePlanSelection($input: CachePlanSelectionInput!) {
    cachePlanSelection(input: $input) {
        success
    }
}
